import FooterExpansionContent from './FooterExpansionContent'

export default FooterExpansionContent
